import { defineComponent as _defineComponent } from 'vue'
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { SnowplowPersonContext } from '@/helpers/tracking/providers/snowplow-contexts';
import { useSearchSuggesterStore } from '@/helpers/composables/useStores';


export default /*#__PURE__*/_defineComponent({
  __name: 'TitleCreditName',
  props: {
    name: { default: '' },
    id: { default: 0 },
    role: null
  },
  setup(__props: any) {

const props = __props as { name: string, id: number, role?: string };



const { goToSearch } = useSearchSuggesterStore();

function clicked(searchString: { searchString: string; personId: number }) {
	goToSearch(searchString);

	const personContext = new SnowplowPersonContext(searchString.personId, searchString.searchString);
	TrackingHelper.trackEvent(
		'persons_credit_name',
		{
			action: 'clicked',
			label: props.role,
			property: searchString.personId + '',
		},
		[personContext]
	);
}

return { __sfc: true,props, goToSearch, clicked }
}

})